import React from 'react';

const CareersHero: React.FC = () => {
  return (
    <section className="careers-hero">
      <div className="container">
        <div className="hero-content">
          <h1>Where builders shape the future of cloud and AI</h1>
          <p>
            Launch your career in cloud computing, artificial intelligence, data engineering, 
            and tech education at Global Sansys. Join a team that's transforming how organizations 
            learn, build, and scale in the digital age.
          </p>
          <div className="hero-buttons">
            <a href="#" className="btn-primary">View all open roles</a>
            <a href="#" className="btn-secondary">Explore early careers</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersHero;